export default "__VITE_ASSET__8df7f14f__"